export const locale = {
    id: 'pl',
};
